("use strict");
import { from, of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, catchError, map, concatMap } from "rxjs/operators";

import { getRequestHeader } from "../../_helpers/request.header";
import { payloadFormatter } from "../../_helpers/encryption.helper";
import { ajaxError } from "../_actions";
import { schedulePaymentsConstants } from "../_constants";
import {
  changeIterationStatusComplete,
  changeIterationStatusError,
  scheduleIterationListComplete,
  scheduleIterationListError,
  schedulePaymentsListComplete,
  schedulePaymentsListError,
  stopSchedulePaymentComplete,
  stopSchedulePaymentError,
} from "../_actions/schedulePayments.actions";

export const schedulePaymentsListEpic = (actions$) =>
  actions$.pipe(
    ofType(schedulePaymentsConstants.SCHEDULE_PAYMENTS_LIST_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/schedulePayments/schedulePaymentsList",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            schedulePaymentsListComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(schedulePaymentsListError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const changeIterationStatusEpic = (actions$) =>
  actions$.pipe(
    ofType(schedulePaymentsConstants.CHANGE_ITERATION_STATUS_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/schedulePayments/changeIterationStatus",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            changeIterationStatusComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(changeIterationStatusError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const scheduleIterationListEpic = (actions$) =>
  actions$.pipe(
    ofType(schedulePaymentsConstants.SCHEDULE_ITERATION_LIST_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/schedulePayments/scheduleIterationList",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            scheduleIterationListComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(scheduleIterationListError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const stopSchedulePaymentEpic = (actions$) =>
  actions$.pipe(
    ofType(schedulePaymentsConstants.STOP_SCHEDULE_PAYMENT_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/schedulePayments/stopSchedulePayment",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            stopSchedulePaymentComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(stopSchedulePaymentError(error), ajaxError(error)),
          ),
        );
    }),
  );
